/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'

export const showOptions = blockProps => {
	const {
		showTitle = true,
		showHeaderButton = false,
		showFooterButton = true,
	} = blockProps.attributes

	return applyFilters( 'cartzillagb.products-carousel.show', {
		headerSpacing: showHeaderButton,
		titleSpacing: showTitle && ! showHeaderButton,
		footerSpacing: showFooterButton,
	}, blockProps )
}
